import * as graphql from '@treams/treams-network';
import { InboxTaskType } from '@treams/treams-network';

import InboxEvaluationOpenTask from './tasks/InboxEvaluationOpenTask';
import InboxFeedbackRequestPendingTask from './tasks/InboxFeedbackRequestPendingTask';
import InboxMomentStartTask from './tasks/InboxMomentStartTask';

const inboxTaskMap = {
	[graphql.InboxTaskType.EvaluationSubmissionOpen]: InboxEvaluationOpenTask,
	[graphql.InboxTaskType.FeedbackRequestPending]: InboxFeedbackRequestPendingTask,
	[graphql.InboxTaskType.MomentStart]: InboxMomentStartTask,
};

export default function InboxTask(props: {
	task: graphql.InboxTask;
	tasks?: graphql.InboxTask[];
	finishedTask?: graphql.InboxTask;
	type?: InboxTaskType;
	refresh: () => void;
}) {
	const [markAsSeen] = graphql.useMarkInboxTaskMutation();

	const { task } = props;

	const Component = inboxTaskMap[task.type];

	const onAction = () => {
		markAsSeen({
			variables: {
				input: {
					id: props.task.id,
				},
			},
		});
	};

	return (
		<>
			<Component
				task={task}
				finishedTask={props.finishedTask}
				tasks={props.tasks}
				type={props.type}
				onAction={onAction}
				refresh={props.refresh}
			/>
		</>
	);
}
